import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as articleActions from '../../actions/articleActions';
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from '../../actions/common/modalActions';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';
import ArticlesList from './ArticlesList';
import ArticleListDivs from './ArticleListDivs';
import MediaQuery from 'react-responsive';
import CustomModal from '../../components/CustomModal';
import CustomPagination from '../../components/common/CustomPagination';
import {toastr} from 'react-redux-toastr';
import BaseList from '../../components/common/list/BaseList.jsx';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import PlaceholderTable from "../common/PlaceholderTable";

class ArticlesPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'articles';
        this.idToDelete = null;

        this.state = {
            page: 1,
            showDeleteModal: false,
            actions: this.getRequiredActions()
        };

        if (props.match.params.page) {
            this.state.page = props.match.params.page;
        }

        this.onDelete = this.onDelete.bind(this);
        this.onClone = this.onClone.bind(this);
    }


    getRequiredActions() {
        return [
            this.props.actions.loadArticles(1)
        ];
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    onDelete(id) {
        this.idToDelete = id;
        this.props.actions.showModal();
    }

    confirmDelete() {
        if (this.idToDelete !== null) {
            this.props.actions.deleteArticle(this.idToDelete).then(() => {
                this.idToDelete = null;
                this.props.actions.hideModal();
                this.props.actions.loadArticles(this.state.page, this.getSortParams(this.props));
                toastr.success(this.props.intl.formatMessage(messages.articleDeleted));
            });
        } else {
            toastr.error(this.props.intl.formatMessage(messages.articleErrorDelete));
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.props.actions.hideModal();
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadArticles(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page: pageNum.selected + 1});
    }

    onClone(id) {
        this.props.actions.showSpinner();
        this.props.actions.cloneArticle(id)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.articleCloned));
            })
            .catch((err) => {
                this.props.actions.hideSpinner();
            })
    }

    render() {
        const {articles} = this.props;
        let articlesData = articles.data || [];

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable} errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return(
                            <div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.articleDeleteModalTitle)}
                                    modalContent={<p>{this.props.intl.formatMessage(messages.articleDeleteQuestion)}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {this.confirmDelete()}}
                                />
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card m-b-20">
                                            <div className="card-block">
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">
                                                            {this.props.intl.formatMessage(messages.articleListTitle)}
                                                        </h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link
                                                            to="/nyhed/skab"
                                                            className="btn btn-primary waves-effect pull-right"
                                                        >
                                                            {this.props.intl.formatMessage(messages.articleCreate)}</Link>
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <ArticleListDivs
                                                        articles={articlesData}
                                                        onDelete={this.onDelete}
                                                        onClone={this.onClone}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <ArticlesList
                                                        articles={articlesData}
                                                        onDelete={this.onDelete}
                                                        onClone={this.onClone}
                                                        listId={this.listId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={articles.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>

        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        articles: state.articles,
        showDeleteModal: state.showModal,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...articleActions,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ArticlesPage));


// WEBPACK FOOTER //
// ./web/src/components/articles/ArticlesPage.jsx